// extracted by mini-css-extract-plugin
var _1 = "TextArea_additionRow__88c45";
var _2 = "TextArea_base__2c551";
var _3 = "TextArea_clear__906d7";
var _4 = "TextArea_disabled__6b185";
var _5 = "TextArea_error__e3251";
var _6 = "TextArea_fluid__e6f25";
var _7 = "TextArea_ghost__06561";
var _8 = "TextArea_hasPostfix__b9b5d";
var _9 = "TextArea_medium__73a42";
var _a = "TextArea_mini__6316a";
var _b = "TextArea_postfix__71140";
var _c = "TextArea_root__ff2dc";
var _d = "TextArea_textarea__4fafd";
export { _1 as "additionRow", _2 as "base", _3 as "clear", _4 as "disabled", _5 as "error", _6 as "fluid", _7 as "ghost", _8 as "hasPostfix", _9 as "medium", _a as "mini", _b as "postfix", _c as "root", _d as "textarea" }
